import React from 'react';
import {Card, CardContent, CardHeader, Typography,CardMedia} from '@material-ui/core'
import styled from 'styled-components'
import logo from '../images/Container.png'


const CardContainer = styled.div`
width:50%;
transition:1s cubic-bezier(0.075, 0.82, 0.165, 1);
margin: 0 auto;
margin-top:50px;
font-family:'Barlow';
&:hover{
    transform: translateY(-10px);
}
`


const Project = (props) => {
    return (  
    <CardContainer>
        <Card>
           <CardHeader title={props.titolo}/>
           <CardMedia
            style={{height:'200px'}}
            image={props.imglink}
            title="Paella dish"
            />
           
           
            <CardContent>
                <Typography variant='h6'>description:</Typography>
                <Typography paragraph>
                    {props.descrizione}
                </Typography>
                
                    
                <Typography>
                    Technology used: {props.tecn}
                </Typography>
           </CardContent>
        </Card>
    </CardContainer> );
}
 
export default Project;